/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { BEM } from "@adapptio/lib-components";
import { ToolbarTitle } from "../../../../../ui/components/Toolbar/ToolbarTitle";
import { ToolbarSpacer } from "../../../../../ui/components/Toolbar/ToolbarSpacer";
import { TOOLBAR_BUTTON_SIZE, ToolbarButton } from "../../../../../ui/components/Toolbar/ToolbarButton";
import { DROPDOWN_STYLE, IDropdownMenuItem } from "../../../../../ui/components/DropdownMenu";
import { ACTION_BUTTON_STYLE } from "../../../../../ui/components/ActionButton";
import { ThemeModel } from "../../../Common/ThemeModel";
import { ThemeEditSelection } from "../../../Common/ThemeEditSelection";

function createAddMenu(themeModel: ThemeModel, selection: ThemeEditSelection): IDropdownMenuItem[] {
	const viewProps = themeModel.getModel().props.spec.props;
	const mapModel = viewProps.styles;

	const addStyle = () => {
		const style = mapModel.schema.addElement(
			mapModel,
			mapModel.schema.getUniqueKey(mapModel, "style", true),
			undefined,
			true
		);

		selection.selectStyle(mapModel, style);
	};

	return [
		{
			id: "style",
			label: "Add Style",
			icon: "mdi/palette",
			onClick: () => addStyle()
		}
	];
}

export interface IThemeEditorOutlineToolbarProps {
	className?: string;
	themeModel: ThemeModel;
}

export const ThemeEditorOutlineToolbar: React.FC<IThemeEditorOutlineToolbarProps> = ({
	className,
	themeModel
}) => {
	const baseClass = BEM("edt-theme-editor-outline-toolbar");

	const addMenuItems = useMemo(() => createAddMenu(themeModel, themeModel.getSelection()), [ themeModel ]);

	if (className) {
		baseClass.add(className);
	}

	return (
		<>
			<ToolbarTitle>Outline</ToolbarTitle>
			<ToolbarSpacer grow={1} />
			<ToolbarButton
				icon="mdi/plus"
				size={TOOLBAR_BUTTON_SIZE.SMALL}
				menuItems={addMenuItems}
				menuStyle={DROPDOWN_STYLE.COMPACT}
				style={ACTION_BUTTON_STYLE.PRIMARY}
			/>
		</>
	);
};
